'use client';
import Image from 'next/image';
import { ChevronDownIcon } from '@/components/icons';
import { DealerSelector } from '@/components/organisms/DealerSelector';
import { ContactSalesDropdown } from '@/components/molecules/Header/ContactSalesDropdown';
import { AccountSettingsDropdown } from '@/components/molecules/Header/AccountSettingsDropdown';

interface HeaderProps {
  onMenuToggle?: () => void;
  showMenuButton?: boolean;
}

export const Header = ({ onMenuToggle, showMenuButton = false }: HeaderProps) => {
  return (
    <header className="sticky z-999 top-0 bg-menu-background h-24 flex items-center drop-shadow">
      <div className="flex justify-between items-center w-full px-6 container mx-auto relative">
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <DealerSelector />
        </div>

        {/* Right side controls */}
        <div className="flex items-center gap-3">
          <ContactSalesDropdown />
          <AccountSettingsDropdown />
        </div>
      </div>
    </header>
  );
};
